module.exports = __webpack_public_path__ + "static/media/Camplete TurnMill.0ca89be8.png";